// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "tabs__segmentGroupWrapper-3r1C0";
var _4 = "tabs__header-KTOcL";
var _5 = "tabs__value-1hyhH";
var _6 = "tabs__segment-1USqU";
var _7 = "tabs__segmentDate-lyor8";
var _8 = "tabs__logo-3vxMz";
var _9 = "tabs__segmentRoute-3I1bT";
var _a = "tabs__timeWrapper-19JTg";
var _b = "tabs__timeInRoute-3vPI2";
var _c = "tabs__timeLine-1XDwE";
var _d = "tab__airline_detail-ADklt";
var _e = "tab__airline_name-2M5Bf";
var _f = "tabs__segmentGroupCheckin-vXY0o";
var _10 = "tabs__segmentStatus-2SgRI";
var _11 = "tab__container-qhgXg";
var _12 = "tab__airline-39TJh";
var _13 = "tabs__segmentGroupWrapper_mobile-13tas";
var _14 = "tabs__headerWrapper-2I7TM";
export { _1 as "__esModule", _2 as "tablet", _3 as "tabs__segmentGroupWrapper", _4 as "tabs__header", _5 as "tabs__value", _6 as "tabs__segment", _7 as "tabs__segmentDate", _8 as "tabs__logo", _9 as "tabs__segmentRoute", _a as "tabs__timeWrapper", _b as "tabs__timeInRoute", _c as "tabs__timeLine", _d as "tab__airline_detail", _e as "tab__airline_name", _f as "tabs__segmentGroupCheckin", _10 as "tabs__segmentStatus", _11 as "tab__container", _12 as "tab__airline", _13 as "tabs__segmentGroupWrapper_mobile", _14 as "tabs__headerWrapper" }
export default { "__esModule": _1, "tablet": _2, "tabs__segmentGroupWrapper": _3, "tabs__header": _4, "tabs__value": _5, "tabs__segment": _6, "tabs__segmentDate": _7, "tabs__logo": _8, "tabs__segmentRoute": _9, "tabs__timeWrapper": _a, "tabs__timeInRoute": _b, "tabs__timeLine": _c, "tab__airline_detail": _d, "tab__airline_name": _e, "tabs__segmentGroupCheckin": _f, "tabs__segmentStatus": _10, "tab__container": _11, "tab__airline": _12, "tabs__segmentGroupWrapper_mobile": _13, "tabs__headerWrapper": _14 }
